import React from "react";
import {Dropdown, DropdownChangeEvent} from "primereact/dropdown";
import { useGetSupportedTimezones } from "api/api-hooks/user-hooks";
import { recordToSelectItems } from "utils/utils";
import {useUserState} from "store/user-store";
import {logInfo} from "utils/logging-utils";



export default function TimezoneSelectFragment() {
    const companyTimezone = useUserState((state) => state.getCompanyTimezone());
    const setCompanyTimezone = useUserState((state) => state.setCompanyTimezone);

    const tzSelectData = useGetSupportedTimezones()
    const timezoneSelections = recordToSelectItems(tzSelectData.data)

    logInfo("company tz ", companyTimezone);

    const onCompanyTzChange = (e: DropdownChangeEvent) => {
        logInfo("Setting company timezone to ", e.value);
        setCompanyTimezone(e.value);
    }

    if(!timezoneSelections) {
        return <div>Loading timezones...</div>
    }

    return <div>
    Company:<Dropdown placeholder="Select Company Timezone"
        value={companyTimezone}
        options={timezoneSelections}
        filter
        filterMatchMode="contains"
        onChange={onCompanyTzChange}
        optionValue="value"
    />
    </div>
}